import { Link } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import { usePersonalBoard } from '../hooks'
import { KanbanBoard } from './KanbanBoard'

/**
 * Widget dashboardu pokazujący personalny kanban zalogowanego usera w ograniczonej
 * wysokości (600px) + link do pełnego widoku /tasks. Cienki composer wokół
 * {@link KanbanBoard} - cała logika DnD i wireup już tam siedzi.
 */
export function MyTasksKanbanWidget() {
  const board = usePersonalBoard()

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
        <h2 className="text-sm font-semibold">Moje zadania</h2>
        <Link
          to="/tasks"
          className="inline-flex items-center gap-1 text-xs text-sky-600 hover:underline"
        >
          Pełny widok
          <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
      <div className="h-[560px]">
        {board.isLoading && (
          <p className="p-4 text-sm text-slate-500">Ładowanie boardu…</p>
        )}
        {board.isError && (
          <p className="p-4 text-sm text-red-600">Nie udało się załadować boardu.</p>
        )}
        {board.data && <KanbanBoard board={board.data} showAddColumn={false} />}
      </div>
    </div>
  )
}
